import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import "../css/Homepage.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { Helmet } from "react-helmet-async";
import { delayedToast, isButtonDisabled } from "../lib/customToast.js";
import useAuthStore from "../store/useAuthStore";
import { getBuilderHomePath } from "../utils/builderNavigation";
import useFindBuilderStore from "../store/useFindBuilderStore";
import { useNavigate, useLocation } from "react-router-dom";
import Footerlanding from "../components/Footerlanding";
import Navbarlanding from "../components/Navbarlanding";
import GenericModal from "../components/common/GenericModal";
import SuccessPopup from "../components/common/SuccessPopup";
import useCustomerProfileStore from "../store/customer/useProfileStore";
import calculateCustomerProfileCompletion from "../layout/customer/CustomerDetails/calculateCustomerProfileCompletion";
import { User, Loader2, Home, CheckCircle, ArrowRight, PencilRuler, Building2, Palette, TreePine, Wrench, Gavel, ShieldCheck, Package, Cpu, ChevronRight, MessageSquare, Calendar, Eye, Headphones, Map, Building, Star, Quote, ClipboardList, Banknote, FileText, Award, LineChart } from "lucide-react";
import ImageModal from "../components/common/ImageModal";
// MobileBottomNav moved to AppLayout
import useBlogStore from "../store/useBlogStore";
import { axiosEnquiryInstance } from "../lib/axiosInstance.js";
import { motion } from "framer-motion";

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-50px" },
  transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] }
};

const staggerContainer = {
  initial: {},
  whileInView: { transition: { staggerChildren: 0.1 } },
  viewport: { once: true, margin: "-50px" }
};


const Homepage = () => {
  useEffect(() => {


    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = "https://www.googletagmanager.com/gtag/js?id=G-23CPLZP6XG";
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-23CPLZP6XG');
    `;
    document.head.appendChild(script2);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);

  // 🔒 Prevent browser back navigation on this page
  useEffect(() => {
    const handleBack = (event) => {
      event.preventDefault();
      // Push same page again → user cannot go back
      window.history.pushState(null, "", window.location.href);
    };

    // Add a new history state
    window.history.pushState(null, "", window.location.href);

    // When user presses back
    window.addEventListener("popstate", handleBack);

    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, []);


  const [fontSize, setFontSize] = useState(
    window.innerWidth < 768 ? "18px" : "28px"
  );
  const navigate = useNavigate();
  const location = useLocation();
  const { token, userType: authUserType, user: authUser } = useAuthStore();
  const {
    mappedDistricts,
    mappedTaluks,
    setSelectedState: setGlobalSelectedState,
    setSelectedDistrict: setGlobalSelectedDistrict,
    setSelectedTaluk: setGlobalSelectedTaluk,
    fetchMappedDistricts,
    fetchMappedTaluks,
  } = useFindBuilderStore();

  const [isBlinking, setIsBlinking] = useState(true);
  const [localSelectedState, setLocalSelectedState] = useState("Tamil Nadu");
  const [localSelectedDistrict, setLocalSelectedDistrict] = useState("");
  const [localSelectedTaluk, setLocalSelectedTaluk] = useState("");

  const [loginDropdownOpen, setLoginDropdownOpen] = useState(false);
  const [navSolid, setNavSolid] = useState(false);
  const whyTrustRef = useRef(null);



  const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);

  const { profile: customerProfile, fetchProfile: fetchCustomerProfile } =
    useCustomerProfileStore();
  const [customerProfileCompletion, setCustomerProfileCompletion] = useState(0);

  const {
    posts: blogPosts,
    isLoading: isBlogLoading,
    fetchPosts: fetchBlogPosts,
  } = useBlogStore();

  const [testimonials, setTestimonials] = useState([]);
  const [isLoadingTestimonials, setIsLoadingTestimonials] = useState(true);
  const [demoProjects, setDemoProjects] = useState([]);
  const [isLoadingDemoProjects, setIsLoadingDemoProjects] = useState(true);
  const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const loginDropdownRef = useRef(null);

  useEffect(() => {
    fetchMappedDistricts("Tamil Nadu");
    fetchBlogPosts(1, 3);

    const fetchTestimonials = async () => {
      setIsLoadingTestimonials(true);
      try {
        const response = await axiosEnquiryInstance.get("/testimonials?page=landing");
        if (response.data.success) {
          setTestimonials(response.data.testimonials);
        }
      } catch (error) {
        console.error("Failed to fetch testimonials:", error);
      } finally {
        setIsLoadingTestimonials(false);
      }
    };
    fetchTestimonials();

    const fetchDemoProjects = async () => {
      setIsLoadingDemoProjects(true);
      try {
        const response = await axiosEnquiryInstance.get("/demo-projects?active=1");
        if (response.data.success) {
          setDemoProjects(response.data.demo_projects || []);
        }
      } catch (error) {
        console.error("Failed to fetch demo projects:", error);
      } finally {
        setIsLoadingDemoProjects(false);
      }
    };
    fetchDemoProjects();
  }, [fetchMappedDistricts, fetchBlogPosts]);

  useEffect(() => {
    if (localSelectedDistrict) {
      fetchMappedTaluks(localSelectedDistrict);
    } else {
      useFindBuilderStore.setState({ mappedTaluks: { taluks: [] } });
      setLocalSelectedTaluk("");
    }
  }, [localSelectedDistrict, fetchMappedTaluks]);

  useEffect(() => {
    if (token && authUserType === "customer" && authUser?.customerId) {
      if (!customerProfile) {
        fetchCustomerProfile();
      }
    }
  }, [token, authUserType, authUser, fetchCustomerProfile, customerProfile]);

  useEffect(() => {
    if (customerProfile) {
      const completion = calculateCustomerProfileCompletion(customerProfile);
      setCustomerProfileCompletion(completion);
    }
  }, [customerProfile]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        loginDropdownRef.current &&
        !loginDropdownRef.current.contains(event.target)
      ) {
        setLoginDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLoginRedirect = (selectedUserType) => {
    if (token && authUserType) {
      if (authUserType !== selectedUserType) {
        delayedToast.error(`You are already logged in as a ${authUserType}.`, {}, "login-redirect-btn");
        return;
      }
      if (authUserType === "builder") navigate(getBuilderHomePath(authUser));
      else navigate("/customer/projectinvite");
    } else {
      navigate(`/login?type=${selectedUserType}`);
    }
    setLoginDropdownOpen(false);

  };

  const handleFindBuilderClick = () => {
    if (!localSelectedDistrict) {
      delayedToast.error("Please select a district.", {}, "find-builder-btn");
      return;
    }
    if (!localSelectedTaluk) {
      delayedToast.error("Please select a taluk.", {}, "find-builder-btn");
      return;
    }
    setGlobalSelectedState(localSelectedState);
    setGlobalSelectedDistrict(localSelectedDistrict);
    setGlobalSelectedTaluk(localSelectedTaluk);
    localStorage.setItem("selectedDistrict", localSelectedDistrict);
    localStorage.setItem("selectedTaluk", localSelectedTaluk);
    navigate("/builderslist");
  };

  useEffect(() => {
    const blinkInterval = setInterval(() => {
      setIsBlinking((prev) => !prev);
    }, 800);
    return () => clearInterval(blinkInterval);
  }, []);

  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    {
      id: 1,
      src: "/assets/Ducktail-latest-project.jpg",
      colSpan: "md:col-span-2",
    },
    {
      id: 2,
      src: "/assets/Ducktail-Latest-project-3.jpg",
      colSpan: "md:col-span-1",
    },
    {
      id: 3,
      src: "/assets/Ducktail-Latest-project-2.jpg",
      colSpan: "md:col-span-1",
    },
    {
      id: 4,
      src: "/assets/Ducktail-latest.jpg",
      colSpan: "md:col-span-1",
    },
  ];

  useEffect(() => {
    const handleResize = () =>
      setFontSize(window.innerWidth < 768 ? "18px" : "28px");
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSignupCardClick = (signupUserType) => {
    setIsSignupModalOpen(false);
    navigate(
      signupUserType === "builder" ? "/builder/signup" : "/customer/signup"
    );
  };

  useEffect(() => {
    if (location.state?.scrollToServices) {
      const servicesSection = document.querySelector("#services");
      if (servicesSection) {
        const yOffset =
          servicesSection.getBoundingClientRect().top +
          window.pageYOffset -
          100;
        window.scrollTo({ top: yOffset, behavior: "smooth" });
      }
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  useEffect(() => {
    const savedDistrict = localStorage.getItem("selectedDistrict");
    const savedTaluk = localStorage.getItem("selectedTaluk");
    if (savedDistrict) setLocalSelectedDistrict(savedDistrict);
    if (savedTaluk) setLocalSelectedTaluk(savedTaluk);
  }, []);

  // Transparent on hero + "Why Thousands Trust"; white navbar only after scrolling past that section
  useEffect(() => {
    const NAV_OFFSET = 72;

    const updateNavbar = () => {
      const section = whyTrustRef.current;
      if (!section) {
        setNavSolid(window.scrollY > 400);
        return;
      }
      const { bottom } = section.getBoundingClientRect();
      setNavSolid(bottom <= NAV_OFFSET);
    };

    updateNavbar();
    window.addEventListener("scroll", updateNavbar, { passive: true });
    window.addEventListener("resize", updateNavbar);
    return () => {
      window.removeEventListener("scroll", updateNavbar);
      window.removeEventListener("resize", updateNavbar);
    };
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      return new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    } catch (e) {
      return "Invalid Date";
    }
  };

  return (
    <div className="w-full bg-white font-poppins selection:bg-blue-100 selection:text-blue-900 pb-20 lg:pb-0 overflow-x-hidden">
      <Helmet>
        <title>DUCKTAIL | The Construction Platform</title>
        <meta name="description" content="Ducktail is a tech-driven all-in-one construction platform that connects homeowners with verified builders to build dream homes across India." />
        <link rel="canonical" href="https://www.ducktail.in/" />
      </Helmet>

      <div className="fixed top-0 left-0 right-0 z-50">
        <Navbarlanding transparent={!navSolid} />
      </div>

      <SuccessPopup
        isOpen={isSuccessPopupOpen}
        onClose={() => setIsSuccessPopupOpen(false)}
        message="Thank you! We will contact you within 24 hours."
      />

      <GenericModal
        isOpen={isSignupModalOpen}
        onClose={() => setIsSignupModalOpen(false)}
        title="Join Ducktail As"
        size="max-w-lg"
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4">
          <div
            onClick={() => handleSignupCardClick("builder")}
            className="flex flex-col items-center p-4 border border-gray-300 rounded-lg hover:shadow-lg hover:border-blue-500 transition-all duration-200 cursor-pointer bg-gray-50"
          >
            <img src="/assets/builder.png" alt="Builder" className="w-24 h-24 object-contain mb-3" />
            <h3 className="text-md font-semibold text-gray-700">Builder</h3>
            <p className="text-xs text-gray-500 text-center mt-1">Showcase your projects and connect with clients.</p>
          </div>
          <div
            onClick={() => handleSignupCardClick("customer")}
            className="flex flex-col items-center p-4 border border-gray-300 rounded-lg hover:shadow-lg hover:border-blue-500 transition-all duration-200 cursor-pointer bg-gray-50"
          >
            <img src="/assets/young-man.png" alt="Customer" className="w-24 h-24 object-contain mb-3" />
            <h3 className="text-md font-semibold text-gray-700">Customer</h3>
            <p className="text-xs text-gray-500 text-center mt-1">Find verified builders for your dream project.</p>
          </div>
        </div>
      </GenericModal>

      {/* ===== HERO SECTION ===== */}
      <div className="relative min-h-[75vh] md:min-h-[70vh] w-full bg-white overflow-hidden flex flex-col">
      <style jsx>{`
        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>

      {/* Background Image Container - Responsive: different images for mobile vs desktop */}
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        {/* Mobile image */}
        <img
          src="/assets/Home Mobile Bannner.png"
          alt="Modern House"
          className="md:hidden absolute inset-0 w-full h-full object-cover object-center"
        />
        {/* Desktop image */}
        <img
          src="/assets/Homepage%20Banner.png"
          alt="Modern House"
          className="hidden md:block absolute inset-0 w-full h-full"
        />
        <div className="absolute inset-0 bg-black/5"></div>
      </div>
      {/* Left Side Content & Gradient */}
      <div className="relative z-10 w-full md:w-[80%] lg:w-[75%] xl:w-[70%] flex flex-col justify-center flex-1 px-8 md:px-16 lg:px-24 pb-12 pt-20 md:pt-32">
        {/* White Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/85 to-transparent md:from-white md:via-white/90 pointer-events-none"></div>
        <div className="relative z-20 space-y-4">
          {/* Headings Group */}
          <div>
            {/* Brand heading — mobile: one line, larger than sub lines; desktop: original sizes */}
            <div className="text-base md:text-xl lg:text-2xl font-black text-gray-900 leading-none md:leading-[1.1] tracking-tight md:tracking-tighter uppercase whitespace-nowrap md:whitespace-normal mb-1.5 md:mb-2">
              Ducktail - The construction platform
            </div>

            {/* Subheadings — smaller than main on mobile; tight line spacing */}
            <div className="space-y-0.5">
              <h2 className="text-gray-900 text-sm md:text-sm font-bold leading-tight">
                Build Your <span className="text-amber-500">Modern</span> Home
              </h2>
              <p className="text-gray-900 text-sm md:text-sm font-bold leading-tight m-0">
                With Civil Certified &amp; Verified Builders
              </p>
            </div>
          </div>

          {/* Trust Badges Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-3">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center border border-amber-100 shrink-0">
                <ShieldCheck className="w-5 h-5 text-amber-600" />
              </div>
              <div>
                <h5 className="text-gray-900 text-[11px] font-black uppercase tracking-wider">10 Year Warranty</h5>
                <p className="text-gray-500 text-[10px] font-medium">Quality checks & Warranty Protection</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center border border-amber-100 shrink-0">
                <CheckCircle className="w-5 h-5 text-amber-600" />
              </div>
              <div>
                <h5 className="text-gray-900 text-[11px] font-black uppercase tracking-wider">Civil Certified & Verified Builders</h5>
                <p className="text-gray-500 text-[10px] font-medium">Strictly 10+ Steps Verification Process</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center border border-amber-100 shrink-0">
                <Cpu className="w-5 h-5 text-amber-600" />
              </div>
              <div>
                <h5 className="text-gray-900 text-[11px] font-black uppercase tracking-wider">Digital DashBoard</h5>
                <p className="text-gray-500 text-[10px] font-medium">Track Everything digitally.</p>
              </div>
            </div>
          </div>

          {/* Search Builders Section */}
          <div className="pt-3">
            <div className="bg-white/90 backdrop-blur-2xl p-4 md:p-6 rounded-3xl border-2 border-gray-300 shadow-2xl shadow-black/10 max-w-6xl w-full">
              <div className="mb-3">
                <h4 className="text-gray-900 text-xs font-black uppercase tracking-widest mb-1">Find Verified Builders</h4>
                <p className="text-gray-500 text-[10px] font-medium">Select your location to explore certified builders near you.</p>
              </div>
              <div className="flex flex-col sm:flex-row gap-2">
                <div className="flex flex-col sm:flex-row flex-1 gap-2">
                  <div className="relative flex-1">
                    <select
                      className="w-full bg-white border border-gray-300 px-4 py-2.5 rounded-xl text-gray-800 text-xs font-bold appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-amber-500/50"
                      value={localSelectedDistrict}
                      onChange={(e) => setLocalSelectedDistrict(e.target.value)}
                    >
                      <option value="">Select District</option>
                      {mappedDistricts?.districts?.map((d) => (
                        <option key={d} value={d}>{d}</option>
                      ))}
                    </select>
                  </div>
                  <div className="relative flex-1">
                    <select
                      className="w-full bg-white border border-gray-300 px-4 py-2.5 rounded-xl text-gray-800 text-xs font-bold appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-amber-500/50"
                      value={localSelectedTaluk}
                      onChange={(e) => setLocalSelectedTaluk(e.target.value)}
                      disabled={!localSelectedDistrict || !mappedTaluks?.taluks?.length}
                    >
                      <option value="">Select Taluk</option>
                      {mappedTaluks?.taluks?.map((t) => (
                        <option key={t} value={t}>{t}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <button
                  onClick={handleFindBuilderClick}
                  className="px-6 py-2.5 bg-amber-500 hover:bg-amber-600 text-white font-black text-[10px] uppercase tracking-widest rounded-xl shadow-lg transition-all active:scale-[0.98]"
                >
                  Find Builders
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

      {/* ===== WHY THOUSANDS TRUST SECTION ===== */}
      <motion.div
        ref={whyTrustRef}
        id="why-thousands-trust"
        {...fadeInUp}
        className="w-full bg-white py-12 px-6 border-b border-gray-100 scroll-mt-32"
      >
        <style>{`
          @keyframes why-trust-scroll {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .why-trust-track {
            display: flex;
            gap: 20px;
            width: max-content;
            animation: why-trust-scroll 40s linear infinite;
          }
          .why-trust-track:hover {
            animation-play-state: paused;
          }
        `}</style>

        {/* Desktop: original side-by-side layout — heading left + divider + 5-col grid */}
        <div className="hidden md:flex max-w-7xl mx-auto items-start gap-8">
          <div className="w-48 shrink-0">
            <h2 className="text-lg md:text-xl font-black text-gray-900 leading-snug mb-2">
              Why Thousands <br />Trust <span className="text-amber-500">Ducktail?</span>
            </h2>
            <p className="text-[11px] text-gray-500 leading-relaxed">
              India's 1st Construction Regulated Platform
            </p>
          </div>
          <div className="w-px bg-gray-200 self-stretch" />
          <motion.div
            variants={staggerContainer}
            initial="initial"
            whileInView="whileInView"
            viewport={{ once: true }}
            className="flex-1 grid grid-cols-5 gap-6"
          >
            {[
              { label: "24x7 Support system", sub: "Always here for you", icon: <Headphones className="w-6 h-6 text-amber-500" /> },
              { label: "Easy Home Loan", sub: "Financial assistance", icon: <Banknote className="w-6 h-6 text-amber-500" /> },
              { label: "Safe & Secure", sub: "Everything digitally Recorded,\n100% clarity", icon: <ShieldCheck className="w-6 h-6 text-amber-500" /> },
              { label: "One stop Solutions", sub: "From Land to Build House all in Under One Roof", icon: <Package className="w-6 h-6 text-amber-500" /> },
              { label: "Organized System", sub: "India's 1st Construction Regulated Platform", icon: <ClipboardList className="w-6 h-6 text-amber-500" /> },
            ].map((item, i) => (
              <motion.div key={i} variants={fadeInUp} className="flex flex-col items-start gap-1">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-amber-50 flex items-center justify-center mb-1">
                  {item.icon}
                </div>
                <h4 className="text-[10px] md:text-[11px] font-black text-gray-900 leading-tight whitespace-pre-line">{item.label}</h4>
                <p className="text-[9px] md:text-[10px] text-gray-500 leading-relaxed whitespace-pre-line">{item.sub}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>

        {/* Mobile: heading + infinite scroll marquee — single line */}
        <div className="md:hidden">
          <h2 className="text-lg font-black text-gray-900 leading-snug mb-1">
            Why Thousands Trust <span className="text-amber-500">Ducktail?</span>
          </h2>
          <p className="text-[11px] text-gray-500 leading-relaxed mb-4">
            India's 1st Construction Regulated Platform
          </p>
          <div className="relative overflow-hidden -mx-6">
            <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-10 z-10 bg-gradient-to-r from-white to-transparent" />
            <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-10 z-10 bg-gradient-to-l from-white to-transparent" />
            <div className="why-trust-track py-3 px-3">
              {[...([
                { label: "24x7 Support system", sub: "Always here for you", icon: <Headphones className="w-6 h-6 text-amber-500" /> },
                { label: "Easy Home Loan", sub: "Financial assistance", icon: <Banknote className="w-6 h-6 text-amber-500" /> },
                { label: "Safe & Secure", sub: "Everything digitally Recorded, 100% clarity", icon: <ShieldCheck className="w-6 h-6 text-amber-500" /> },
                { label: "One stop Solutions", sub: "From Land to Build House all in Under One Roof", icon: <Package className="w-6 h-6 text-amber-500" /> },
                { label: "Organized System", sub: "India's 1st Construction Regulated Platform", icon: <ClipboardList className="w-6 h-6 text-amber-500" /> },
              ]), ...([
                { label: "24x7 Support system", sub: "Always here for you", icon: <Headphones className="w-6 h-6 text-amber-500" /> },
                { label: "Easy Home Loan", sub: "Financial assistance", icon: <Banknote className="w-6 h-6 text-amber-500" /> },
                { label: "Safe & Secure", sub: "Everything digitally Recorded, 100% clarity", icon: <ShieldCheck className="w-6 h-6 text-amber-500" /> },
                { label: "One stop Solutions", sub: "From Land to Build House all in Under One Roof", icon: <Package className="w-6 h-6 text-amber-500" /> },
                { label: "Organized System", sub: "India's 1st Construction Regulated Platform", icon: <ClipboardList className="w-6 h-6 text-amber-500" /> },
              ])].map((item, i) => (
                <div key={i} className="flex flex-col items-start gap-1 flex-shrink-0" style={{ width: "150px" }}>
                  <div className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center mb-1">
                    {item.icon}
                  </div>
                  <h4 className="text-[10px] font-black text-gray-900 leading-tight">{item.label}</h4>
                  <p className="text-[9px] text-gray-500 leading-relaxed">{item.sub}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </motion.div>

      {/* ===== SERVICES SECTION ===== */}
      <div id="services" className="w-full bg-white py-6 px-4 scroll-mt-32">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-left md:text-center mb-6">
            <p className="text-amber-600 text-[11px] font-extrabold uppercase tracking-[0.2em] mb-2">Our Services</p>
            <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-2 tracking-tight">
              Complete Construction Solutions
            </h2>
            <p className="text-gray-500 text-xs font-medium leading-relaxed">
              From concept to completion, we provide end-to-end construction services
            </p>
          </div>

          <motion.div 
            variants={staggerContainer}
            initial="initial"
            whileInView="whileInView"
            viewport={{ once: true }}
            className="flex flex-wrap justify-center gap-3 md:gap-4 mb-6 lg:grid lg:grid-cols-4 lg:gap-4 lg:max-w-6xl lg:mx-auto"
          >
            {[
              { title: "Home Loan", desc: "Easy home loans with best interest rates", icon: <Home className="w-5 h-5" />, color: "amber", link: "/homeloan", btnLabel: "Apply Loan" },
              { title: "Housing Plots", desc: "Premium residential plots in top locations", icon: <Map className="w-5 h-5" />, color: "green", link: "/housingplots", btnLabel: "Explore Plots" },
              { title: "Architecture & Design", desc: "Creative designs that inspire", icon: <PencilRuler className="w-5 h-5" />, color: "purple", link: "/archidesign", btnLabel: "Get Designed" },
              // { title: "Construction Consultation", desc: "Expert guidance for your construction journey", icon: <Building2 className="w-5 h-5" />, color: "green", link: "/constructionconsultation", btnLabel: "Consult Now" },
              { title: "Commercial Construction", desc: "Top-tier commercial building solutions", icon: <Building className="w-5 h-5" />, color: "indigo", link: "/premiumconstruction", btnLabel: "Know More" },
              { title: "Landscaping", desc: "Green spaces that enhance living", icon: <TreePine className="w-5 h-5" />, color: "teal", link: "/landscaping", btnLabel: "Explore" },
              { title: "Customer Support", desc: "24/7 dedicated support for your needs", icon: <Headphones className="w-5 h-5" />, color: "sky", link: "/support", btnLabel: "Contact Us" },
              // { title: "Interior Design", desc: "Beautiful interiors that reflect you", icon: <Palette className="w-5 h-5" />, color: "orange", badge: "Coming Soon" },
            ].map((service, index) => (
              <motion.div 
                key={index} 
                variants={fadeInUp}
                onClick={() => service.link && navigate(service.link)}
                className={`bg-white rounded-xl p-4 md:p-5 min-h-[130px] md:min-h-[160px] border border-gray-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_50px_rgba(0,0,0,0.08)] hover:-translate-y-1 transition-all duration-300 group cursor-pointer flex flex-col justify-between relative overflow-hidden w-[calc(50%-6px)] md:w-[calc(33.333%-11px)] lg:w-full ${index === 4 ? "lg:col-start-2" : ""}`}
              >
                {service.badge && (
                  <div className="absolute top-0 right-0 bg-orange-500 text-white text-[8px] font-black px-2 py-1 rounded-bl-lg uppercase tracking-wider z-10">
                    {service.badge}
                  </div>
                )}
                <div>
                  <div className={`w-8 h-8 md:w-10 md:h-10 rounded-xl flex items-center justify-center mb-3 md:mb-4 ${
                    service.color === 'amber' ? 'bg-amber-50 text-amber-500' :
                    service.color === 'blue' ? 'bg-amber-50 text-amber-500' :
                    service.color === 'purple' ? 'bg-purple-50 text-purple-500' :
                    service.color === 'green' ? 'bg-green-50 text-green-500' :
                    service.color === 'orange' ? 'bg-orange-50 text-orange-500' :
                    service.color === 'teal' ? 'bg-teal-50 text-teal-500' :
                    service.color === 'red' ? 'bg-red-50 text-red-400' :
                    service.color === 'indigo' ? 'bg-indigo-50 text-indigo-500' :
                    'bg-sky-50 text-sky-500'
                  }`}>
                    {service.icon}
                  </div>
                  <h3 className="text-gray-900 text-[11px] md:text-[13px] font-bold mb-1">{service.title}</h3>
                  <p className="text-gray-500 text-[9px] md:text-[11px] leading-relaxed mb-3 md:mb-4">{service.desc}</p>
                </div>
                {service.btnLabel && (
                  <div className="flex justify-end mt-auto">
                    <span className={`inline-flex items-center gap-1 text-[9px] md:text-[10px] font-black uppercase tracking-wider px-2.5 py-1 rounded-full transition-all duration-300 ${
                      service.color === 'amber' ? 'bg-amber-50 text-amber-600 group-hover:bg-amber-500 group-hover:text-white' :
                      service.color === 'purple' ? 'bg-purple-50 text-purple-600 group-hover:bg-purple-500 group-hover:text-white' :
                      service.color === 'green' ? 'bg-green-50 text-green-600 group-hover:bg-green-500 group-hover:text-white' :
                      service.color === 'teal' ? 'bg-teal-50 text-teal-600 group-hover:bg-teal-500 group-hover:text-white' :
                      service.color === 'indigo' ? 'bg-indigo-50 text-indigo-600 group-hover:bg-indigo-500 group-hover:text-white' :
                      'bg-sky-50 text-sky-600 group-hover:bg-sky-500 group-hover:text-white'
                    }`}>
                      {service.btnLabel}
                    </span>
                  </div>
                )}
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>

      {/* ===== HOW IT WORKS SECTION ===== */}
      <motion.div 
        {...fadeInUp}
        className="w-full pb-6 pt-2 px-4"
      >
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start lg:items-center gap-8">
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:w-64 shrink-0"
          >
            <p className="text-amber-600 text-[11px] font-extrabold uppercase tracking-[0.2em] mb-2">Our Process</p>
            <h2 className="text-xl md:text-2xl font-black text-gray-900 leading-tight mb-2">
              How it works?
            </h2>
            <p className="text-[11px] text-gray-500 font-medium">
              Simple. Transparent.<br />Hassle-free.
            </p>
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="flex-1 w-full bg-white rounded-[32px] md:rounded-[50px] p-6 md:p-10 border border-gray-100 shadow-[0_20px_60px_rgba(0,0,0,0.05)]"
          >
            <motion.div 
              variants={staggerContainer}
              initial="initial"
              whileInView="whileInView"
              viewport={{ once: true }}
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
            >
              {[
                { num: "1", color: "bg-amber-500", title: "Choose location & Find Your Builder" },
                { num: "2", color: "bg-amber-500", title: "Register in Ducktail as a Customer & get dashboard" },
                { num: "3", color: "bg-amber-500", title: "Plan & Design", sub: "Ducktail Archi team will help you" },
                { num: "4", color: "bg-amber-500", title: "Build with Confidence", sub: "Track Every Progress in your Ducktail Dashboard" },
              ].map((step, i) => (
                <motion.div 
                  key={i} 
                  variants={fadeInUp}
                  className="flex items-center gap-4"
                >
                  <div className={`w-10 h-10 rounded-full ${step.color} text-white flex items-center justify-center font-black shrink-0 shadow-lg`}>
                    {step.num}
                  </div>
                  <div>
                    <h4 className="text-[11px] font-black text-gray-900 leading-tight mb-1">{step.title}</h4>
                    {step.sub && <p className="text-[10px] text-gray-500 leading-tight">{step.sub}</p>}
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </motion.div>
        </div>
      </motion.div>

      {/* ===== LIVE PROJECTS SECTION ===== */}
      <div className="w-full bg-white py-6 px-4">
        <div className="max-w-7xl mx-auto">
          <motion.div 
            {...fadeInUp}
            className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-6"
          >
            <div>
              <p className="text-amber-600 text-[11px] font-extrabold uppercase tracking-[0.2em] mb-2">Ongoing Work</p>
              <div className="flex items-center gap-2">
                <h2 className="text-lg md:text-xl font-black text-gray-900">Live Projects Happening Near You</h2>
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse inline-block"></span>
              </div>
            </div>
            <button
              onClick={() => navigate("/builderslist")}
              className="flex items-center gap-1 text-[11px] font-bold text-gray-500 hover:text-amber-600 transition-colors"
            >
              View all projects
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
            </button>
          </motion.div>

          {/* Live projects — auto-scroll (no arrows), swipe-friendly overflow on touch */}
          <div className="relative overflow-hidden">
            <style>{`
              @keyframes live-projects-scroll {
                0%   { transform: translateX(0); }
                100% { transform: translateX(-50%); }
              }
              .live-projects-track {
                display: flex;
                gap: 20px;
                width: max-content;
                animation: live-projects-scroll 30s linear infinite;
              }
              .live-projects-track:hover {
                animation-play-state: paused;
              }
            `}</style>

            {isLoadingDemoProjects ? (
              <div className="flex justify-center py-16">
                <Loader2 className="w-8 h-8 animate-spin text-amber-500" />
              </div>
            ) : demoProjects.length === 0 ? (
              <p className="text-center text-gray-500 text-sm py-12">No live demo projects to display yet.</p>
            ) : (
              <div className="relative overflow-hidden touch-pan-x">
                <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-10 z-10 bg-gradient-to-r from-white to-transparent" />
                <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-10 z-10 bg-gradient-to-l from-white to-transparent" />
                <div className="live-projects-track pb-8 pt-2">
              {[...demoProjects, ...demoProjects].map((project, i) => (
                <div
                  key={`${project.id}-${i}`}
                  className="bg-black rounded-3xl overflow-hidden shadow-xl hover:shadow-amber-500/10 transition-all duration-500 group cursor-pointer border border-white/5 flex-shrink-0"
                  style={{ width: "280px", minWidth: "280px" }}
                >
                  <div className="relative h-52 sm:h-56 overflow-hidden">
                    <img
                      src={project.image_url || "/assets/image_459ee48f.png"}
                      alt={project.project_name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/10 to-transparent"></div>
                    <span className={`absolute top-3 left-3 ${project.tag_color || "bg-green-500"} text-white text-[8px] font-black uppercase tracking-wider px-2 py-1 rounded-md shadow-lg`}>
                      {project.tag}
                    </span>
                  </div>
                  <div className="p-4 pt-1 relative">
                    <h3 className="text-white text-[13px] font-bold mb-1.5 leading-tight group-hover:text-amber-400 transition-colors">{project.project_name}</h3>
                    <div className="flex items-center gap-1.5 mb-3">
                      <svg className="w-3 h-3 text-green-500 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                      <p className="text-gray-400 text-[9px] font-medium truncate uppercase tracking-wider">{project.location}</p>
                    </div>
                    <div className="space-y-1.5">
                      <div className="flex justify-between items-center">
                        <span className="text-[9px] text-gray-400 font-bold uppercase tracking-widest">{project.progress}% Completed</span>
                      </div>
                      <div className="w-full h-1 bg-gray-800 rounded-full overflow-hidden">
                        <div
                          className="h-full bg-green-500 rounded-full transition-all duration-1000"
                          style={{ width: `${project.progress}%` }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>



      {/* ===== ZERO RISK SECTION ===== */}
      <motion.div 
        {...fadeInUp}
        className="w-full bg-white py-6 border-b border-gray-100"
      >
        <style>{`
          @keyframes trust-scroll {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          @media (max-width: 767px) {
            .trust-track {
              display: flex !important;
              gap: 16px;
              width: max-content;
              animation: trust-scroll 40s linear infinite;
            }
            .trust-track:hover {
              animation-play-state: paused;
            }
          }
        `}</style>

        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-start gap-8">
          <div className="md:w-48 shrink-0">
            <h2 className="text-xl font-black text-gray-900 leading-snug mb-2">
              Build Your Home <br />with <span className="text-amber-500">Zero Risk</span>
            </h2>
            <p className="text-[11px] text-gray-500 leading-relaxed">
              We take care of everything, so you can build with confidence.
            </p>
          </div>
          <div className="hidden md:block w-px bg-gray-200 self-stretch" />

          {/* Desktop: static grid */}
          <motion.div 
            variants={staggerContainer}
            initial="initial"
            whileInView="whileInView"
            viewport={{ once: true }}
            className="hidden md:grid flex-1 grid-cols-5 gap-4 md:gap-6"
          >
            {[
              {
                label: "24x7 Support System",
                sub: "Always here for you",
                icon: <Headphones className="w-6 h-6 text-amber-500" />,
              },
              {
                label: "Easy Home Loan",
                sub: "Financial assistance",
                icon: <Banknote className="w-6 h-6 text-amber-500" />,
              },
              {
                label: "Safe & Secure",
                sub: "Everything digitally recorded, 100% clarity",
                icon: <ShieldCheck className="w-6 h-6 text-amber-500" />,
              },
              {
                label: "One Stop Solutions",
                sub: "From Land to Build House all under One Roof",
                icon: <Building className="w-6 h-6 text-amber-500" />,
              },
              {
                label: "Organized System",
                sub: "India's 1st Construction Regulated Platform",
                icon: <ClipboardList className="w-6 h-6 text-amber-500" />,
              },
            ].map((item, i) => (
              <motion.div key={i} variants={fadeInUp} className="flex flex-col items-start gap-1">
                <div className="w-12 h-12 rounded-xl bg-amber-50 flex items-center justify-center mb-1">
                  {item.icon}
                </div>
                <h4 className="text-[11px] font-black text-gray-900 leading-tight">{item.label}</h4>
                <p className="text-[10px] text-gray-500 leading-relaxed">{item.sub}</p>
              </motion.div>
            ))}
          </motion.div>

          {/* Mobile: infinite scroll marquee */}
          <div className="md:hidden w-full relative overflow-hidden -mx-6">
            {/* Fade edges */}
            <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-8 z-10 bg-gradient-to-r from-white to-transparent" />
            <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-8 z-10 bg-gradient-to-l from-white to-transparent" />
            <div className="trust-track py-3 px-2">
              {[...[
                { label: "24x7 Support System", sub: "Always here for you", icon: <Headphones className="w-6 h-6 text-amber-500" /> },
                { label: "Easy Home Loan", sub: "Financial assistance", icon: <Banknote className="w-6 h-6 text-amber-500" /> },
                { label: "Safe & Secure", sub: "Everything digitally recorded, 100% clarity", icon: <ShieldCheck className="w-6 h-6 text-amber-500" /> },
                { label: "One Stop Solutions", sub: "From Land to Build House all under One Roof", icon: <Building className="w-6 h-6 text-amber-500" /> },
                { label: "Organized System", sub: "India's 1st Construction Regulated Platform", icon: <ClipboardList className="w-6 h-6 text-amber-500" /> },
              ], ...[
                { label: "24x7 Support System", sub: "Always here for you", icon: <Headphones className="w-6 h-6 text-amber-500" /> },
                { label: "Easy Home Loan", sub: "Financial assistance", icon: <Banknote className="w-6 h-6 text-amber-500" /> },
                { label: "Safe & Secure", sub: "Everything digitally recorded, 100% clarity", icon: <ShieldCheck className="w-6 h-6 text-amber-500" /> },
                { label: "One Stop Solutions", sub: "From Land to Build House all under One Roof", icon: <Building className="w-6 h-6 text-amber-500" /> },
                { label: "Organized System", sub: "India's 1st Construction Regulated Platform", icon: <ClipboardList className="w-6 h-6 text-amber-500" /> },
              ]].map((item, i) => (
                <div key={i} className="flex flex-col items-start gap-1 flex-shrink-0" style={{ width: "140px" }}>
                  <div className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center mb-1">
                    {item.icon}
                  </div>
                  <h4 className="text-[10px] font-black text-gray-900 leading-tight">{item.label}</h4>
                  <p className="text-[9px] text-gray-500 leading-relaxed">{item.sub}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </motion.div>

      {/* ===== BLOG SECTION ===== */}
      <motion.div 
        {...fadeInUp}
        className="w-full bg-white pt-10 pb-6 px-4"
      >
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-6">
            <div className="max-w-xl">
              <p className="text-amber-600 text-[11px] font-extrabold uppercase tracking-[0.2em] mb-2">Insights & Inspiration</p>
              <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-2 tracking-tight">Our Construction Blog</h2>
              <p className="text-gray-500 mt-2 text-xs font-medium leading-relaxed">
                Stay updated with the latest trends, tips, and professional advice.
              </p>
            </div>
            <button onClick={() => navigate("/blogs")} className="flex items-center gap-2 text-xs font-black text-amber-600 hover:text-amber-700 transition-colors group">
              View All Articles
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>

          {isBlogLoading ? (
            <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-amber-500" /></div>
          ) : (
            <motion.div 
              variants={staggerContainer}
              initial="initial"
              whileInView="whileInView"
              viewport={{ once: true }}
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
            >
              {blogPosts.slice(0, 3).map((post, i) => (
                <motion.div key={i} variants={fadeInUp}>
                  <Link to={`/blog/${post.slug}`} className="group cursor-pointer">
                    <div className="relative h-48 overflow-hidden rounded-2xl mb-4 shadow-lg">
                      <img src={post.featured_image_url || "/assets/image_38f2a15c.png"} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" alt={post.title} />
                    </div>
                    <div className="space-y-2">
                      <div className="flex items-center gap-3 text-[10px] text-gray-400 font-bold uppercase tracking-widest">
                        <Calendar className="w-3 h-3" /> {formatDate(post.published_at)}
                      </div>
                      <h3 className="text-lg font-black text-gray-900 group-hover:text-blue-600 transition-colors leading-tight">{post.title}</h3>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </motion.div>
          )}
        </div>
      </motion.div>



      {/* ===== TESTIMONIALS SECTION ===== */}
      <motion.div 
        {...fadeInUp}
        className="w-full bg-white py-8 relative overflow-hidden"
      >
        <style>{`
          @keyframes testimonial-scroll {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .testimonial-track {
            display: flex;
            gap: 24px;
            width: max-content;
            animation: testimonial-scroll 28s linear infinite;
          }
          .testimonial-track:hover {
            animation-play-state: paused;
          }
        `}</style>

        <div className="max-w-7xl mx-auto px-4">
          <div className="text-left md:text-center mb-6">
            <p className="text-amber-600 text-[11px] font-extrabold uppercase tracking-[0.2em] mb-2">Testimonials</p>
            <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-4 tracking-tight">What Our Happy Customers Say</h2>
          </div>
        </div>

        {isLoadingTestimonials ? (
          <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-amber-500" /></div>
        ) : testimonials.length === 0 ? null : (
          <div className="max-w-7xl mx-auto px-4">
            <div className="relative overflow-hidden">
              {/* Fade edges — scoped inside the container */}
              <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 z-10 bg-gradient-to-r from-white to-transparent" />
              <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 z-10 bg-gradient-to-l from-white to-transparent" />

              <div className="testimonial-track py-4">
                {[...testimonials, ...testimonials].map((t, i) => (
                  <div
                    key={i}
                    className="bg-white p-5 rounded-[24px] border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-500 flex flex-col flex-shrink-0"
                    style={{ width: "340px", minHeight: "190px" }}
                  >
                    {/* Quote Icon */}
                    <div className="w-8 h-8 rounded-full bg-amber-50 flex items-center justify-center mb-3">
                      <Quote className="w-4 h-4 text-amber-500 fill-amber-500/10" />
                    </div>

                    {/* Testimonial Text */}
                    <p className="text-gray-700 text-[12px] font-medium leading-relaxed mb-3 flex-1 line-clamp-3">
                      "{t.text || t.testimonial_text}"
                    </p>

                    {/* Rating */}
                    <div className="flex gap-1 mb-4">
                      {[...Array(5)].map((_, idx) => (
                        <Star
                          key={idx}
                          className={`w-3 h-3 ${idx < (t.rating || 5) ? "text-orange-400 fill-orange-400" : "text-gray-200"}`}
                        />
                      ))}
                    </div>

                    {/* Profile Info */}
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full overflow-hidden bg-gray-50 border border-gray-100 shrink-0">
                        <img
                          src={t.image_url || "/assets/young-man.png"}
                          className="w-full h-full object-cover"
                          alt={t.name}
                        />
                      </div>
                      <div>
                        <h4 className="text-[12px] font-bold text-gray-900 leading-none mb-0.5">{t.name}</h4>
                        <p className="text-[9px] text-gray-400 font-bold uppercase tracking-widest">
                          {t.location || "Verified Client"}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </motion.div>



      <Footerlanding />
    </div>
  );
};

export default Homepage;